import(/* webpackMode: "eager", webpackExports: ["MyAccountContainer"] */ "/vercel/path0/apps/portals/src/app/[portalSlug]/(main)/myaccount/MyAccountContainer.tsx");
